import "./Spinner.css";
export default function Spinner() {
  return (
    <div className="spinner-ellipsis"><div></div><div></div><div></div><div></div></div>
  )

}
